import ApiClient from '../client';
import axios from 'axios';
import Config from '../../services/config.service';
import { ErrorService } from '@/services/error-service.js';
import i18n from '@/common/i18n/i18n.js';
const config = new Config();
const path = require('path');

class DatasetAPI extends ApiClient {

  datasetsRoles=undefined;

  datasetsGranularities=undefined;

  datasetsKinds=undefined;

  datasetsLicences=undefined;

  datasetsRecordTypes=undefined;

  datasetsRestrictions=undefined;

  datasetsTopics=undefined;

  datasetsUpdateFrequencies=undefined;

  datasetsCategories=undefined;

  constructor() {
    super();
  }

  async getDatasetsCount() {
    const route = path.join(
      this.DATASET_API_PATH,
      'datasets-count/'
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async getDatasetsList(
    page = 1,
    usergroup,
    recordTypes,
    filters,
    controller
  ) {
    let route = path.join(
      this.DATASET_API_PATH,
      `datasets/?page_size=${config.itemsPerPage.datasets}&page=${page}`
    );
    if (usergroup) {
      route = route.concat('', `&usergroup_id=${usergroup}`);
    }
    if (recordTypes && recordTypes.length) {
      route = route.concat('', `&record_type=${recordTypes.join(',')}`);
    }
    for (const filter in filters) {
      route = route.concat('', `&${filter}=${filters[filter]}`);
    }
    const response = await this.get(
      route,
      { signal: controller.signal }
    );
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async orderDatasetsList(
    direction,
    field,
    page = 1,
    usergroup,
    recordTypes,
    filters,
    controller
  ) {
    let route = path.join(
      this.DATASET_API_PATH,
      `datasets/?page_size=${config.itemsPerPage.datasets}&ordering=${direction}${field}&page=${page}`
    );
    if (usergroup) {
      route = route.concat('', `&usergroup_id=${usergroup}`);
    }
    if (recordTypes && recordTypes.length) {
      route = route.concat('', `&record_type=${recordTypes.join(',')}`);
    }
    for (const filter in filters) {
      route = route.concat('', `&${filter}=${filters[filter]}`);
    }
    const response = await this.get(
      route,
      { signal: controller.signal }
    );
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async getDataset(id) {
    try {
      const route = path.join(
        this.DATASET_API_PATH,
        `datasets/${id}/`
      );
      const response = await this.get(route);
      if (response.status === 200) {
        return response.data;
      }
      return false;
    } catch (error) {
      if (error && error.response && error.response.status === 404) {
        ErrorService.onError(
          false,
          i18n.messages[i18n.locale].datasetDetail.errorMessages.noDataset
        );
      } else {
        ErrorService.onError(
          false,
          i18n.messages[i18n.locale].messages.error.default
        );
      }
      throw error;
    }
  }

  async getDatasetPermissions(id, filters, page = 1) {
    let route = path.join(
      this.DATASET_API_PATH,
      `datasets/${id}/usergroup-permissions/?page=${page}`
    );
    if (Object.values(filters).some(el => el && el.length > 0)) {
      for (const filter in filters) {
        if (filters[filter] && filters[filter].length > 0) {
          route = route.concat('', `&${filter}=${filters[filter].join(',')}`);
        }
      }
    }
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async orderDatasetPermissions(direction, field, id, filters, page = 1) {
    let route = path.join(
      this.DATASET_API_PATH,
      `datasets/${id}/usergroup-permissions/?ordering=${direction}${field}&page=${page}`
    );
    if (Object.values(filters).some(el => el && el.length > 0)) {
      for (const filter in filters) {
        if (filters[filter] && filters[filter].length > 0) {
          route = route.concat('', `&${filter}=${filters[filter].join(',')}`);
        }
      }
    }
    const response = await this.get(
      route,

    );
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async setDatasetPermissions(level, data) {
    const route = path.join(`${this.DATASET_API_PATH}`, `usergroup-permission-actions/?action=set_permission_level_${level}`);
    const response = await this.put(
      route,
      data,

    );
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async createDataset(data) {
    const route = path.join(
      this.DATASET_API_PATH,
      'datasets/'
    );
    const response = await this.post(route, data);
    if (response.status === 201) {
      return response.data;
    }
    return false;
  }

  async updateDataset(id, data, scenarioId) {
    const route = path.join(
      this.DATASET_API_PATH,
      `datasets/${id}/`
    );
    const response = await this.put(route, data);
    if (response.status === 200) {
      await this.buildDatasetIndex(id, scenarioId);
      return response.data;
    }
    return false;
  }
  async publishDataset(id) {
    const route = path.join(
      this.DATASET_API_PATH,
      `datasets/${id}/publish/?asynchrone=True`
    );
    const response = await this.get(route);
    if (response.status === 202) {
      return response.data;
    }
    return false;
  }
  async unpublishDataset(id) {
    const route = path.join(
      this.DATASET_API_PATH,
      `datasets/${id}/unpublish/?asynchrone=True`
    );
    const response = await this.get(route);
    if (response.status === 202) {
      return response.data;
    }
    return false;
  }

  async buildDatasetIndex(id, scenarioId) {
    if(!scenarioId){
      return this.unpublishDataset(id);
    }
    else{
      return this.publishDataset(id);
    }
    /*
    const route = path.join(
      this.DATASET_API_PATH,
      `datasets/${id}/_scenarios/${scenarioId}/run/?asynchrone=${asynchrone}`
    );
    const response = await this.post(route);
    if (response.status === 202) {
      return response.data;
    }
    return false;*/
  }

  async patchDataset(id, data) {
    const route = path.join(
      this.DATASET_API_PATH,
      `datasets/${id}/`
    );
    const response = await this.patch(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async setDatasetThumbnail(id, data) {
    const route =  path.join(
      this.DATASET_API_PATH,
      `datasets/${id}/thumbnail/`
    );
    const response = await this.put(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async removeDatasetThumbnail(id) {
    const route =  path.join(
      this.DATASET_API_PATH,
      `datasets/${id}/thumbnail/`
    );
    const response = await this.delete(route);
    if (response.status === 204) {
      return response.data;
    }
    return false;
  }

  async deleteDataset(id) {
    const route =  path.join(
      this.DATASET_API_PATH,
      `datasets/${id}/`
    );
    const response = await this.delete(route);
    if (response.status === 204) {
      return true;
    }
    return false;
  }

  async getDatasetsCategories() {
    if(this.datasetsCategories){
      return this.datasetsCategories;
    }
    const route =  path.join(
      this.DATASET_API_PATH,
      'categories/'
    );
    const response = await this.get(route);
    if (response.status === 200) {
      this.datasetsCategories=response.data;
      return response.data;
    }
    return false;
  }

  async getDatasetsGranularities() {
    if(this.datasetsGranularities){
      return this.datasetsGranularities;
    }
    const route =  path.join(
      this.DATASET_API_PATH,
      'granularities/'
    );
    const response = await this.get(route);
    if (response.status === 200) {
      this.datasetsGranularities=response.data;
      return response.data;
    }
    return false;
  }

  async getDatasetsLicences() {
    if(this.datasetsLicences){
      return this.datasetsLicences;
    }
    const route =  path.join(
      this.DATASET_API_PATH,
      'licenses/'
    );
    const response = await this.get(route);
    if (response.status === 200) {
      this.datasetsLicences=response.data;
      return response.data;
    }
    return false;
  }

  async getDatasetsTopics() {
    if(this.datasetsTopics){
      return this.datasetsTopics;
    }
    const route =  path.join(
      this.DATASET_API_PATH,
      'topics/'
    );
    const response = await this.get(route);
    if (response.status === 200) {
      this.datasetsTopics=response.data;
      return response.data;
    }
    return false;
  }

  async getDatasetsKinds() {
    if(this.datasetsKinds){
      return this.datasetsKinds;
    }
    const route = path.join(
      this.DATASET_API_PATH,
      'kinds/'
    );
    const response = await this.get(route);
    if (response.status === 200) {
      this.datasetsKinds=response.data;
      return response.data;
    }
    return false;
  }

  async getDatasetsRestrictions() {
    if(this.datasetsRestrictions){
      return this.datasetsRestrictions;
    }
    const route = path.join(
      this.DATASET_API_PATH,
      'restrictions/'
    );
    const response = await this.get(route);
    if (response.status === 200) {
      this.datasetsRestrictions=response.data;
      return response.data;
    }
    return false;
  }

  async getDatasetsUpdateFrequencies() {
    if(this.datasetsUpdateFrequencies){
      return this.datasetsUpdateFrequencies;
    }
    const route = path.join(
      this.DATASET_API_PATH,
      'update-frequencies/'
    );
    const response = await this.get(route);
    if (response.status === 200) {
      this.datasetsUpdateFrequencies=response.data;
      return response.data;
    }
    return false;
  }

  async getDatasetsRecordTypes() {
    if(this.datasetsRecordTypes){
      return this.datasetsRecordTypes;
    }
    const route = path.join(
      this.DATASET_API_PATH,
      'record-types/'
    );
    const response = await this.get(route);
    if (response.status === 200) {
      this.datasetsRecordTypes=response.data;
      return response.data;
    }
    return false;
  }

  async getDatasetsRoles() {
    if(this.datasetsRoles){
      return this.datasetsRoles;
    }
    const route = path.join(
      this.DATASET_API_PATH,
      'contact-roles/'
    );
    const response = await this.get(route);
    if (response.status === 200) {
      this.datasetsRoles=response.data;
      return response.data;
    }
    return false;
  }

  async getCurrentDatasetRoles(id) {
    try {
      const route = path.join(
        this.DATASET_API_PATH,
        `datasets/${id}/contact-roles/`
      );
      const response = await this.get(route);
      if (response.status === 200) {
        return response.data;
      }
      return false;
    } catch (err) {
      return false;
    }
  }

  async createDatasetRole(datasetId, data) {
    const route = path.join(
      this.DATASET_API_PATH,
      `datasets/${datasetId}/contact-roles/`
    );
    const response = await this.post(route, data);
    if (response.status === 201) {
      return response.data;
    }
    return false;
  }

  async updateDatasetRole(datasetId, data, roleId, force = false) {
    const route = path.join(
      this.DATASET_API_PATH,
      `datasets/${datasetId}/contact-roles/${roleId}/${force ? '?force=true' : ''}`
    );
    const response = await this.put(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async removeDatasetRole(datasetId, roleId) {
    const route = path.join(
      this.DATASET_API_PATH,
      `datasets/${datasetId}/contact-roles/${roleId}/`
    );
    const response = await this.delete(route);
    if (response.status === 204) {
      return response.data;
    }
    return false;
  }

  async getContact(id) {
    const route = path.join(
      this.DATASET_API_PATH,
      `contacts/${id}/`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async getContacts(usergroupId, page) {
    let route = path.join(
      this.DATASET_API_PATH,
      'contacts/'
    );
    if (usergroupId) {
      route = route + `?usergroup_id=${usergroupId}`;
      if (page) {
        route = route + `&page=${page}`;
      }
    } else {
      if (page) {
        route = route + `?page=${page}`;
      }
    }
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async createContact(data) {
    const route = path.join(
      this.DATASET_API_PATH,
      'contacts/'
    );
    const response = await this.post(route, data, );
    if (response.status === 201) {
      return response.data;
    }
    return false;
  }

  async updateContact(id, data) {
    const route = path.join(
      this.DATASET_API_PATH,
      `contacts/${id}/`
    );
    const response = await this.put(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async removeContact(id) {
    const route = path.join(
      this.DATASET_API_PATH,
      `contacts/${id}/`
    );
    const response = await this.delete(route);
    if (response.status === 204) {
      return response.data;
    }
    return false;
  }

  async getDatasetLogs(datasetId, page = 1) {
    const route = path.join(
      this.DATASET_API_PATH,
      `datasets/${datasetId}/activity/?page=${page}`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  async callReactAgent(prompt, token, onProgress = null) {
    const reactAgentUrl = process.env.VUE_APP_REACT_AGENT_URL || 'http://localhost:5001';

    // Step 1: Submit the task
    const submitRoute = `${reactAgentUrl}/api/submit-react-agent`;

    let taskId;
    try {
      const submitResponse = await axios.post(submitRoute, {
        prompt: prompt,
        token: token
      }, {
        timeout: 30000,  // 30 seconds for submission
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (submitResponse.status === 202 && submitResponse.data.task_id) {
        taskId = submitResponse.data.task_id;
      } else {
        throw new Error('Failed to submit task: invalid response');
      }
    } catch (error) {
      console.error('[callReactAgent] Failed to submit task:', error);
      if (error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
        throw new Error('The ReactAgent server is not accessible. Verify that it is running on port 5001 (or the port configured in VUE_APP_REACT_AGENT_URL).');
      }
      throw error;
    }

    // Step 2: Poll for task status
    const statusRoute = `${reactAgentUrl}/api/check-react-agent-status/${taskId}`;
    const maxPollingTime = 240000; // 4 minutes max
    const pollInterval = 5000; // Poll every 5 seconds
    const startTime = Date.now();

    let polling = true;
    let lastProgress = null; // Track last progress to avoid duplicate logs
    while (polling) {
      // Check if we've exceeded max polling time
      if (Date.now() - startTime > maxPollingTime) {
        throw new Error('Task execution exceeded maximum time limit');
      }

      try {
        const statusResponse = await axios.get(statusRoute, {
          timeout: 10000, // 10 seconds timeout for each poll
          headers: {
            'Content-Type': 'application/json'
          }
        });

        if (statusResponse.status === 200 && statusResponse.data) {
          const taskStatus = statusResponse.data.status;
          const progress = statusResponse.data.progress;
          const iterationContent = statusResponse.data.iteration_content;

          // Report progress if callback provided and progress changed
          if (onProgress && progress && progress !== lastProgress) {
            onProgress(progress, iterationContent);
            lastProgress = progress;
          }

          if (taskStatus === 'completed') {
            polling = false;
            return statusResponse.data.result;
          } else if (taskStatus === 'failed') {
            const errorMsg = statusResponse.data.error || 'Task failed with unknown error';
            console.error('[callReactAgent] Task failed:', errorMsg);
            polling = false;
            throw new Error(errorMsg);
          } else if (taskStatus === 'pending' || taskStatus === 'running') {
            // Task still in progress, wait and poll again (no log here to avoid spam)
            await new Promise(resolve => setTimeout(resolve, pollInterval));
            continue;
          } else {
            polling = false;
            throw new Error(`Unknown task status: ${taskStatus}`);
          }
        } else {
          throw new Error('Invalid response from status endpoint');
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          throw new Error('Task not found or expired');
        }
        // For network errors during polling, continue polling (might be temporary)
        if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED') {
          console.warn('[callReactAgent] Network error during polling, retrying...', error.message);
          await new Promise(resolve => setTimeout(resolve, pollInterval));
          continue;
        }
        throw error;
      }
    }
  }
  
  async getDatasetFollowers(datasetId) {
    const route = path.join(
      this.DATASET_API_PATH,
      `datasets/${datasetId}/followers/`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

}

const datasetAPI = new DatasetAPI();
export default datasetAPI;
